import l from "react";
import a from "classnames";
import e from "./label.module.scss.js";
function n({
  text: r,
  children: o,
  preventDefault: s,
  textColor: t = "#000",
  labelColor: m = t,
  noPadded: c
}) {
  const d = s ? "div" : "label";
  return /* @__PURE__ */ l.createElement(
    d,
    {
      "data-testid": "label",
      style: {
        "--text-color": t,
        "--label-color": m
      },
      className: a({
        [e.label]: !0
      })
    },
    /* @__PURE__ */ l.createElement(
      "div",
      {
        className: a({
          [e.label__text]: !0,
          [e.label__text__noPadded]: c
        })
      },
      r
    ),
    o
  );
}
export {
  n as Label
};
//# sourceMappingURL=Label.js.map
